module.exports = __webpack_public_path__ + "static/media/wait.3a2872b5.png";